'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _option = require('../option');

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OtherOptionControl = function OtherOptionControl(props) {
  var enabled = props.enabled,
      checked = props.checked,
      onChange = props.onChange,
      type = props.type,
      optionProps = props.optionProps;


  if (enabled) {
    return _react2.default.createElement(_option2.default, _extends({ type: type, checked: checked, text: 'Other', onChange: onChange }, optionProps));
  }
  return null;
};

OtherOptionControl.propTypes = {
  checked: _propTypes2.default.bool,
  enabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  optionProps: _propTypes2.default.object,
  type: _propTypes2.default.oneOf(['pills', 'checklist', 'radio'])
};

exports.default = OtherOptionControl;